import axios from 'axios'

import { API, APIActivity, APIActivityV2 } from '../constants/general'
import { getTokenLocalStorage, removeUserDataLocalStorage } from '../utils/localStorage'

export const Api = axios.create({
    baseURL: API
})

export const ApiActivity = axios.create({
    baseURL: APIActivity
})

export const ApiActivityV2 = axios.create({
    baseURL: APIActivityV2
})

Api.interceptors.request.use(
    (config) => {
        const token = getTokenLocalStorage()

        if (token) {
            config.headers = {
                Authorization: `Bearer ${token}`
            }
        }

        return config
    },
    (error) => {
        return Promise.reject(error)
    }
)

Api.interceptors.response.use(
    (response) => {
        return response
    },
    (error) => {
        if (error.response.status === 401) {
            console.log('error.response', error.response.status)
            removeUserDataLocalStorage()
            if (!window.location.pathname.includes('login'))
                window.location.href = `/login?redirectSuccess=${window.location.pathname}`
        }

        return Promise.reject(error)
    }
)

ApiActivity.interceptors.request.use(
    (config) => {
        const token = getTokenLocalStorage()

        if (token) {
            config.headers = {
                Authorization: `Bearer ${token}`
            }
        }

        return config
    },
    (error) => {
        return Promise.reject(error)
    }
)

ApiActivity.interceptors.response.use(
    (response) => {
        return response
    },
    (error) => {
        if (error.response.status === 401) {
            console.log('error.response', error.response.status)
            removeUserDataLocalStorage()
            if (!window.location.pathname.includes('login'))
                window.location.href = `/login?redirectSuccess=${window.location.pathname}`
        }

        return Promise.reject(error)
    }
)

ApiActivityV2.interceptors.request.use(
    (config) => {
        const token = getTokenLocalStorage()

        if (token) {
            config.headers = {
                Authorization: `Bearer ${token}`
            }
        }

        return config
    },
    (error) => {
        return Promise.reject(error)
    }
)

ApiActivityV2.interceptors.response.use(
    (response) => {
        return response
    },
    (error) => {
        if (error.response.status === 401) {
            console.log('error.response', error.response.status)
            removeUserDataLocalStorage()
            if (!window.location.pathname.includes('login'))
                window.location.href = `/login?redirectSuccess=${window.location.pathname}`
        }

        return Promise.reject(error)
    }
)
